import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const CustomTable = ({ headers, rows, headerStyles, rowStyles, month }) => {
  let columnWidths = ["50%", "20%", "20%", "10%"];
  console.log("first21", month, headers);
  const getFormattedHeaders = () => {
    if (!month) return headers;

    try {
      const date = new Date(month);
      if (isNaN(date.getTime())) return headers;

      const monthNamesShort = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const yearSuffix = String(date.getFullYear()).slice(-2);

      // Month labels
      const currentMonthLabel = `${
        monthNamesShort[date.getMonth()]
      } ${yearSuffix}`;
      const prevMonthDate = new Date(date);
      prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);
      const previousMonthLabel = `${
        monthNamesShort[prevMonthDate.getMonth()]
      } ${String(prevMonthDate.getFullYear()).slice(-2)}`;

      // Quarter labels
      const getQuarter = (d) => Math.floor(d.getMonth() / 3) + 1;

      const currentQuarter = `Q${getQuarter(date)}' ${yearSuffix}`;
      const prevQuarterDate = new Date(date);
      prevQuarterDate.setMonth(prevQuarterDate.getMonth() - 3);
      const previousQuarter = `Q${getQuarter(prevQuarterDate)}' ${String(
        prevQuarterDate.getFullYear()
      ).slice(-2)}`;

      return headers.map((header) => {
        return header
          .replace("Current Month", currentMonthLabel)
          .replace("Previous Month", previousMonthLabel)
          .replace("Current Quarter", currentQuarter)
          .replace("Previous Quarter", previousQuarter);
      });
    } catch (e) {
      return headers;
    }
  };

  const dynamicHeaders = getFormattedHeaders();

  return (
    <TableContainer component={Paper} style={{ marginTop: "1rem", backgroundColor: "#ffffff" }}>
      <Table>
        <TableHead>
          <TableRow>
            {dynamicHeaders.map((header, index) => (
              <TableCell
                key={index}
                style={{
                  width: columnWidths[index],
                  fontWeight: "500",
                  letterSpacing: "0.5px",
                  backgroundColor: "#1C486B",
                  color: "white",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                  padding: "8px",
                  border: "1px solid #ddd",
                  ...headerStyles,
                  textAlign: index === 0 ? "left" : "right",
                }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex} style={{ backgroundColor: "#ffffff" }}>
              {Object.values(row).map((cell, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  style={{
                    padding: "8px",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "19px",
                    border: "1px solid #ddd",
                    backgroundColor: "#ffffff",
                    ...rowStyles,
                    textAlign: cellIndex === 0 ? "left" : "right",
                  }}
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
